import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Icon, List } from '@pella/sash-framework';
import { CTA } from '../../';

const LinkList = ({ links, className, variant = 'black', ...other }) => {
	const [active, setActive] = useState(0);

	const onBtnClick = () => setActive(!active);

	return (
		<div
			className={`linkList ${className || ''}`}
			{...other}
		>
			<button
				className={`relative block w-full cursor-pointer border p-2.5 text-sm font-semibold uppercase lg:hidden ${variant === 'white' ? 'border-white text-white' : 'border-black text-black'}`}
				onClick={onBtnClick}
			>
				In This Section
				<Icon
					name='arrow_drop_down'
					className='absolute right-2 top-1/2 -translate-y-1/2 text-28px'
				/>
			</button>

			<List
				bullets='none'
				className={`z-10 !border-t-0 max-lg:divide-y max-lg:border max-lg:shadow-lg lg:flex lg:space-x-4 ${variant === 'white' ? 'border-white' : 'border-black'} ${active ? 'block' : 'max-lg:hidden'}`}
			>
				{links?.[0] &&
					links.map((link, index) => (
						<li
							key={index}
							className='flex-none text-sm lg:text-base'
						>
							<CTA
								data={link}
								className={`block px-4 py-2 font-semibold uppercase max-lg:no-underline lg:p-0 ${variant === 'white' ? 'text-white' : 'text-black'}`}
							/>
						</li>
					))}
			</List>
		</div>
	);
};

LinkList.propTypes = {
	links: PropTypes.array,
	className: PropTypes.string,
	variant: PropTypes.oneOf(['white', 'black']),
};

export default LinkList;
